export default "__VITE_ASSET__7310755d__"